import { IoMdImage } from "react-icons/io";
import { FaFilePdf } from "react-icons/fa6";
import styles from "./index.module.css";


const PartnerDocumentCard = ({
    documents,
    handleView,
    downloadDocument,
}: PartnerDocumentCardProps) => {
    const iconImages: Record<string, JSX.Element> = {
        pdf: <FaFilePdf className="text-red-500 " />,
        images: <IoMdImage className="text-green-500" />,
    };

    return (
        <div className="overflow-y-auto h-[65vh]">
            {documents && documents.length > 0 ? (
                documents.map((document: PartnerDocument, index: number) => {
                    const isPdf = document.fileUrl?.endsWith(".pdf");
                    const type = isPdf ? "pdf" : "images";

                    return (
                        <div
                            key={index}
                            className="flex flex-col sm:flex-row justify-between items-start sm:items-center shadow-md border p-3 rounded-lg bg-white my-2 gap-3 transition-all hover:shadow-lg"
                        >
                            <div className="flex items-center w-full sm:w-auto flex-1 gap-3 min-w-0">
                                <div className="flex-shrink-0 text-xl">
                                    {iconImages[type]}
                                </div>
                                <div
                                    className="text-gray-800 text-[15px] font-medium break-words leading-tight"
                                >
                                    {document.fileName}
                                </div>
                            </div>

                            <div className="w-full sm:w-auto flex-shrink-0">
                                <div className="flex flex-col sm:flex-row gap-2 w-full">
                                    <button
                                        className={styles.mydocButton}
                                        onClick={() => handleView(document)}
                                    >
                                        View
                                    </button>
                                    <button
                                        onClick={() => downloadDocument(document)}
                                        className={styles.mydocButton}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className="text-center py-10 text-gray-500 font-medium">
                    No Files Found
                </div>
            )}
        </div>
    );
};

export default PartnerDocumentCard;
